import { createAsyncThunk } from '@reduxjs/toolkit'

import { getAdditionalHeaders } from '@/network/common/additionalHeaders'
import { internalRequest } from '@/util/request'

import { getCookie, getUserIdFromAuthToken } from '../providers/authentication/authentication.helpers'

export const fetchShows = createAsyncThunk('fetch-shows', async (_, { rejectWithValue, dispatch }) => {
  const token = getCookie('token')
  const userId = getUserIdFromAuthToken()

  if (!userId) return

  try {
    const { data } = await internalRequest({
      url: `/shows?userId=${userId}`,
      headers: { authorization: token, ...(await getAdditionalHeaders()) },
      method: 'GET',
      dispatch,
    })

    return data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
